import { Paper, Radio, Stack, Typography } from "@mui/material";
import { PollQuestionDto, PollQuestionOptionDto } from "../../../api/psc";

export default function Question(props: {
    question: PollQuestionDto;
    selectOption: (
        question: PollQuestionDto,
        option: PollQuestionOptionDto
    ) => void;
    selectedOption?: number;
}) {
    return (
        <Paper sx={{ p: 1.5 }}>
            <Stack>
                <Typography color="primary">
                    {props.question.question}
                </Typography>
                {props.question.options.map((o) => {
                    return (
                        <Stack direction="row" alignItems="center">
                            <Radio
                                checked={props.selectedOption === o.id}
                                onClick={() =>
                                    props.selectOption(props.question, o)
                                }
                            />
                            <Typography color="text.secondary">
                                {o.option}
                            </Typography>
                        </Stack>
                    );
                })}
            </Stack>
        </Paper>
    );
}
